export default {
    //attendance
    getAttendanceBySectionIdForAdmin: {
      url: "/api/v2/attendance/{section_id}/{event_id}/{month_year}",
      method: "get",
    },
    getExistingAttendanceBySectionId: {
      url: "/api/v2/attendance/today/{section_id}/{event_id}",
      method: "get",
    },
    updateAttendance: {
        url: "/api/v2/attendance/",
        method: "post",
      },
      updateAttendanceHistory: {
          url: "/api/v2/attendance/{attendance_id}",
          method: "put",
        },
  };